<template>
    <div class="paired-container">
        <div class="banner-wrap">
            <div class="banner-title">
                <h3>教育结对空间</h3>
                <p class="banner-subtitle">促进教育交流合作 培养高素质人才</p>
            </div>
            <img src="@/assets/images/paired/paired-banner.png" alt="paired-banner" class="paired-banner" />
        </div>
        <div class="back">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/home' }">研修空间</el-breadcrumb-item>
                <el-breadcrumb-item>结对空间</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="main-content">
            <!-- 我的空间 -->
            <div class="my-spaces-content spaces-content" v-if="mySpacesList.length > 0">
                <div class="my-spaces-content-title flex-align-between">
                    <h4 class="sapce-title flex-align">我的空间</h4>
                    <el-input placeholder="按姓名/学校搜索" prefix-icon="el-icon-search" v-model="spxName" style="width:270px"
                        id="search-spaces" @change="searchSpace">
                    </el-input>
                </div>
                <ul class="space-list">
                    <li class="space-item csp" v-for="(item, index) in mySpacesList" :key="index"
                        @click="goToLibrary(item)">
                        <img :src="item.coverImage" alt="my-space-item-img" class="my-space-item-img" />
                        <div class="space-text flex-column">
                            <p class="space-item-content-title">{{ item.spxName }}</p>
                            <p class="space-item-content-desc wes-2 describe">{{ item.spxIntroduction }}</p>
                            <p class="space-item-content-desc label">#{{ item.span }}</p>
                        </div>
                    </li>
                </ul>
                <Empty :show="mySpacesList.length === 0" :text="'暂无空间'"></Empty>
            </div>
            <!-- 全部空间 -->
            <div class="all-spaces-content spaces-content">
                <div class="flex-align-between all-spaces-content-title">
                    <h4 class="sapce-title flex-align">全部空间</h4>
                    <span class="space-count">共计：{{ allSpacesList.length }}个</span>
                </div>
                <ul class="space-list">
                    <li class="space-item csp" v-for="(item, index) in allSpacesList" :key="index"
                        @click="handleAllSpaceClick(item)">
                        <div class="space-item-content">
                            <img :src="item.coverImage" alt="space-item-img" class="all-space-item-img" />
                            <div class="space-content">
                                <p class="space-item-content-title">{{ item.spxName }}</p>
                                <p class="space-item-content-desc wes-2 describe">{{ item.spxIntroduction }}</p>
                                <p class="space-item-content-desc label">#{{ item.span }}</p>
                            </div>
                        </div>
                    </li>
                </ul>
                <Empty :show="allSpacesList.length === 0" :text="'暂无空间'"></Empty>
                <pagination v-show="pages.total > 0" :total="pages.total" :page.sync="pages.currentPage"
                    :limit.sync="pages.pageSize" :pageSizes="[6, 9, 12]" @pagination="handlePageChange">
                </pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        mapState
    } from "vuex";
    export default {
        data() {
            return {
                spxName: '',
                pages: { //分页
                    currentPage: 1,
                    pageSize: 9,
                    total: 0,
                },
                allSpacesList: [],
                mySpacesList: [],
            };
        },
        computed: {
            ...mapState({
                currentProject: state => state.user.currentProject,
                token: state => state.user.token,
                role: state => state.user.role,
                roleId: state => state.user.roleId,
                userInfo: state => state.user.userInfo
            }),
            // 我的空间 id 集合，用于判断非管理员是否有权限跳转
            mySpaceIds() {
                return (this.mySpacesList || []).map(item => item.id).filter(Boolean)
            }
        },
        methods: {
            goHome() {
                this.$router.go(-1)
            },
            // 翻页
            handlePageChange(data) {
                this.pages.currentPage = data.pageIndex
                this.pages.pageSize = data.pageSize
                this.getAllSpacesList();
            },
            // 获取全部空间列表
            async getAllSpacesList() {
                let params = {
                    page: this.pages.currentPage,
                    limit: this.pages.pageSize,
                    projectId: this.currentProject?.id,
                    spxName: this.spxName
                }
                const res = await this.$Api.Paired.getListByProject(params)
                res.data.records.map(item => {
                    if (item.coverImage && (item.coverImage.startsWith('http://') || item.coverImage.startsWith('https://') || item.coverImage.startsWith('//'))) {
                        item.coverImage = item.coverImage
                    } else {
                        item.coverImage = `${this.downloadURL}${item.coverImage}`
                    }
                })
                this.allSpacesList = res.data.records
                this.pages.total = res.data.total
                console.log(this.allSpacesList)

            },
            // 跳转乐享空间，携带 token、projectId、spxId、userId
            goToLibrary(item) {
                const projectId = this.currentProject?.id ?? ''
                const spxId = item?.spxId ?? item?.id ?? ''
                const userId = this.userInfo?.id ?? ''
                const params = new URLSearchParams({
                    token: this.token || '',
                    projectId: String(projectId),
                    spxId: String(spxId),
                    userId: String(userId),
                    roleId: String(this.roleId ?? ''),
                    source: 'cnuen'
                })
                const url = `https://space.cnuen.net/home?${params.toString()}`
                // const url = `http://localhost:5174/home?${params.toString()}`
                window.open(url, '_blank')
            },
            // 全部空间点击：管理员可跳转全部，非管理员仅可跳转我的空间内的项
            handleAllSpaceClick(item) {
                if (this.role === 'manager') {
                    this.goToLibrary(item)
                    return
                }
                if (this.mySpaceIds.includes(item.id)) {
                    this.goToLibrary(item)
                } else {
                    this.$message.warning('您无该空间查看权限')
                }
            },
            // 获取我的空间列表
            async getMySpacesList() {
                let params = {
                    page: this.pages.currentPage,
                    limit: this.pages.pageSize,
                    projectId: this.currentProject?.id,
                    spxName: this.spxName
                }
                const res = await this.$Api.Paired.getListByOwner(params);
                res.data.records.map(item => {
                    if (item.coverImage && (item.coverImage.startsWith('http://') || item.coverImage.startsWith('https://') || item.coverImage.startsWith('//'))) {
                        item.coverImage = item.coverImage
                    } else {
                        item.coverImage = `${this.downloadURL}${item.coverImage}`
                    }
                })
                this.mySpacesList = res.data.records
            },
            // 搜索空间
            searchSpace(val) {
                console.log('搜索空间', val)
                this.getAllSpacesList()
                this.getMySpacesList()
            },
        },
        mounted() {
            this.getAllSpacesList()
            this.getMySpacesList();
        }
    }
</script>

<style lang="less" scoped>
    @font-face {
        font-family: 'PangMenZhengDaoBiaoTiTiMianFeiBan';
        /* 自定义字体名称 */
        src: url('~@/assets/font/pmzd.ttf') format('truetype');
        font-weight: normal;
        font-style: normal;
    }

    .paired-container {
        .banner-wrap {
            position: relative;

            .banner-title {
                width: 1200px;
                margin: 0 auto;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                color: #2E58F8;
                line-height: 1;

                h3 {
                    font-size: 76px;
                    margin-bottom: 37px;
                    font-family: 'PangMenZhengDaoBiaoTiTiMianFeiBan';
                }

                .banner-subtitle {
                    font-size: 30px;
                }
            }

            .paired-banner {
                max-width: 100%;
            }
        }

        .back {
            width: 1200px;
            margin: 30px auto 200px;
            margin-bottom: 50px;
        }

        .main-content {
            width: 1200px;
            margin: 30px auto 200px;
            display: flex;
            flex-direction: column;
            box-shadow: 0px 2px 10px 0px #F5F8FA;
            border-radius: 8px;
            box-sizing: border-box;
            padding: 30px 30px 0;

            .spaces-content {
                margin-bottom: 50px;
            }

            .sapce-title {
                font-size: 16px;

                &::before {
                    content: '';
                    display: inline-block;
                    width: 22px;
                    height: 24px;
                    margin-right: 7px;
                    background-image: url("~@/assets/images/paired/space-title-icon.png");
                }
            }

            .my-spaces-content-title {
                margin-bottom: 30px;

                .sapce-title {
                    margin-bottom: 0;
                }
            }
        }

        .space-list {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 26px 21px;

            .space-item {
                box-shadow: 0px 0px 13px 0px rgba(127, 127, 127, 0.14);
                border-radius: 10px;
                overflow: hidden;
                line-height: 1;
                transition: all 0.3s ease;
                /* 添加平滑过渡效果 */

                &:hover {
                    box-shadow: 0px 0px 20px 0px rgba(46, 88, 248, 0.2);
                    /* 更明显、更蓝的阴影 */
                    transform: translateY(-5px);
                    /* 向上轻微移动 */
                }
            }

            .space-item-content-title {
                font-size: 16px;
                line-height: 1.5;
            }

            .space-item-content-desc {
                font-size: 14px;
                color: #999999;
                line-height: 1.5;
                letter-spacing: 1px;
            }

            .label {
                font-size: 13px;
                color: #409EFF;
                margin-top: 10px;
            }
        }

        .all-spaces-content {
            .all-spaces-content-title {
                margin-bottom: 30px;
            }

            .space-item-content {
                display: flex;
                flex-direction: column;
                // align-items: center;
            }

            .all-space-item-img {
                width: 100%;
                height: 180px;
            }

            .space-content {
                display: flex;
                flex-direction: column;
                // align-items: center;
                width: 100%;
                box-sizing: border-box;
                padding: 10px;
                overflow: hidden;

                .space-item-content-title {
                    font-size: 16px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width: 100%;
                    line-height: 1.5;
                    font-weight: 700;
                    letter-spacing: 1px;
                }

                .space-item-content-desc {
                    font-size: 14px;
                    color: #999999;
                    line-height: 1.5;
                    letter-spacing: 1px;
                }

                .label {
                    font-size: 13px;
                    color: #409EFF;
                    margin-top: 10px;
                }
            }

            .space-count {
                font-size: 15px;
                color: #909399;
            }

        }

        .my-spaces-content {
            .space-list {
                grid-template-columns: repeat(3, 1fr);
            }

            .my-space-item-img {
                width: 386px;
                height: 242px;
                display: block;
                // background-color: pink;
            }

            .space-text {
                // text-align: center;
                height: 127px;
                justify-content: center;
                box-sizing: border-box;
                padding: 0 10px;
            }

            .space-item-content-title {
                line-height: 33px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-weight: 700;
                letter-spacing: 1px;
            }
        }

        ::v-deep.pagination {
            margin-top: 50px;
            // text-align: right;
        }

    }
</style>